import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import '../../styles/login.css';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import QRCode from 'qrcode';
import otplib from 'otplib/otplib-browser';

function Login(props) {
  const secret = 'CYTYHSMWQRWIFQ4A';
  const token = otplib.authenticator.generate(secret);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState('');
  const [qrModal, setQrModal] = useState(false);
  const [otpSecret, setOtpSecret] = useState('');
  const [otpToken, setOtpToken] = useState('');
  const [otp, setOtp] = useState('');
  const [qrErrors, setQrErrors] = useState('');
  // const [otpCookie, setOtpCookie] = useState(false);
  let otpCookie= false;
  const navigate = useNavigate();
  const canvasRef = useRef(null);

  useEffect(() => {
    checkCookie()
  }, []);

  const checkCookie = () => {
    let cookie = localStorage.getItem('otp');
    if (cookie) {
      const cookieDate = new Date(cookie.split(':')[1]);
      const today = new Date();

      const msSinceCookie = Math.abs(cookieDate.getTime() - today.getTime());
      const daysBetweenDates = msSinceCookie / (24 * 60 * 60 * 1000);

      if (daysBetweenDates < 30) {
        otpCookie = true;
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }

  }

  const login = e => {
    e.preventDefault();

    setErrors('');

    let user = {
      email: email,
      password: password,
    };

    axios
      .post('https://emaildrop.com/login', { user }, {})
      .then(response => {
        if (response.data.error) {
          setErrors(response.data.error);
        } else if (response.data.logged_in && !checkCookie) {
          setQrModal(true);
          setTimeout(() => handleShow(), 500);
        } else if (response.data.logged_in) {
          setIsLoggedIn(true);
          let user = response.data.user[0];

          localStorage.setItem('user', JSON.stringify(user));
          props.dispatch({ type: 'ADD_USER', user });
          navigate('/dashboard')
        } else {
          setErrors('Invalid Email or Password');
        }
      })
      .catch(error => console.log('api errors:', error));
  };

  const handleShow = () => {
    const token = otplib.authenticator.keyuri(email, 'Datagenetx', secret);
    setOtpToken(token);
    QRCode.toCanvas(canvasRef.current, token, function (error) {
      if (error) {
        console.log(error);
      }
    });
  };

  const handleClose = () => {
    setQrModal(false);
  };

  const qrCodeSubmit = e => {
    e.preventDefault();

    const isValid = otplib.authenticator.verify({
      secret: secret,
      token: otp,
    });

    let today = new Date(),
      date =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();

    if (isValid) {
      otpCookie = true;
      setTimeout(() => {
        localStorage.setItem('otp', otp + ':' + date);
        setQrModal(false);
        login(e)
      }
        , 500);
    } else {
      setQrErrors('Invalid Code, Please Try Again');
    }
  };

  return (
    <>
      <Container
        fluid
        className="form-container d-flex justify-content-center align-items-center "
      >
        <Form
          className="login-form shadow p-3 bg-white rounded"
          onSubmit={login}
        >
          <h2 className="mb-3">Login</h2>
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              name="email"
              type="email"
              placeholder="Enter email"
              onChange={e => setEmail(e.target.value)}
              value={email}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </Form.Group>
          {errors && (
            <div className="errors">
              <p className="text-danger">{errors}</p>
            </div>
          )}
          <div className="pb-2">
            <Link to="/forgot">Forgot Your Password?</Link>
          </div>
          <Button className="formButton" type="submit">
            Login
          </Button>
          <p className="mt-3 text-center">
            Need an account?{' '}
            <Link to="/signup" className="signupLink">
              SIGN UP
            </Link>
          </p>
        </Form>

        <Modal show={qrModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Please Confirm Your Identity</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="qrcode">
              <canvas ref={canvasRef} />
            </div>
            <Form className="qrCodeForm" onSubmit={qrCodeSubmit}>
              <Form.Group className="mb-3" controlId="formToken">
                <Form.Label>Code</Form.Label>
                <Form.Control
                  name="otp"
                  type="tel"
                  className="form-control"
                  placeholder="Insert your token"
                  pattern="[0-9]{6}"
                  required
                  value={otp}
                  onChange={e => setOtp(e.target.value)}
                />
              </Form.Group>
              <Button className="formButton" type="submit">
                Login
              </Button>
            </Form>
            {qrErrors && (
              <div className="errors">
                <p className="text-danger">{qrErrors}</p>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
}

const mapStateToProps = function (state) {
  return {
    user: state.userReducer.user,
    isLoggedIn: state.userReducer.isLoggedIn,
  };
};

export default connect(mapStateToProps)(Login);
